module.exports = __webpack_public_path__ + "img/testi1.895c8bdc.svg";